import { render, staticRenderFns } from "./ModalFlashSaleProduct.vue?vue&type=template&id=5135d8d2&scoped=true&"
import script from "./ModalFlashSaleProduct.vue?vue&type=script&lang=js&"
export * from "./ModalFlashSaleProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalFlashSaleProduct.vue?vue&type=style&index=0&id=5135d8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135d8d2",
  null
  
)

export default component.exports